import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCxT9fyrxSB3vikeAv3YHKJyrn7clULDzU",
  authDomain: "handy-hawk.firebaseapp.com",
  projectId: "handy-hawk",
  storageBucket: "handy-hawk.firebasestorage.app",
  messagingSenderId: "307717526382",
  appId: "1:307717526382:web:2905adae5555c8fdba677f",
  measurementId: "G-35G808Z6C2"
};

// Stripe Configuration (Test Mode - Publishable Key is safe for frontend)
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51ShgXWBJfoVxg3xW2HCKBxNo2U7Pm9vC5zbtulymnIVkXNLnimE6EkUkuT6w4mbOu3vXb1m2Hd7Ff3Ns5lXRrr4v00jy41a0N1';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to Functions emulator in development
// NOTE: Check terminal output for actual port - Firebase may use 5001, 5002, etc. depending on availability
if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
  console.log('🔧 Connecting to Firebase Functions emulator on port 5002');
  connectFunctionsEmulator(functions, '127.0.0.1', 5002);
}

export default app;

